import Vue from 'vue'
import Plugin from './plugin'

var Loading = function () {

}

Loading.prototype.start = function () {
  $('body').addClass('loading')
}

Loading.prototype.stop = function () {
  $('body').removeClass('loading')
}

Vue.use(Plugin, new Loading())



// WEBPACK FOOTER //
// ./src/configs/loading/index.js